import { render, staticRenderFns } from "./data-service2.vue?vue&type=template&id=eb8f03de&scoped=true"
import script from "./data-service2.vue?vue&type=script&lang=js"
export * from "./data-service2.vue?vue&type=script&lang=js"
import style0 from "./data-service2.vue?vue&type=style&index=0&id=eb8f03de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb8f03de",
  null
  
)

export default component.exports